import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=5998ee33&scoped=true&"
import script from "./DynamicForm.vue?vue&type=script&lang=ts&"
export * from "./DynamicForm.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicForm.vue?vue&type=style&index=0&id=5998ee33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5998ee33",
  null
  
)

export default component.exports